module.exports = "/_next/static/images/truck10-e8dc2e03b7abdd8a330ce77c5f570e4c.png.webp";